import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22omnyqra.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./InstrumentSans-Regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./InstrumentSans-Medium.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22./InstrumentSans-SemiBold.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22./InstrumentSans-Bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22}],%22display%22:%22block%22,%22preload%22:true,%22variable%22:%22--font-season%22,%22fallback%22:[%22system-ui%22,%22Segoe%20UI%22,%22Roboto%22,%22Helvetica%20Neue%22,%22Arial%22,%22Noto%20Sans%22],%22adjustFontFallback%22:%22Arial%22}],%22variableName%22:%22instrumentSans%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'instrumentSans', 'instrumentSans Fallback', system-ui, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
